import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Caption } from '../../components/Caption/Caption.js';
import { createCustomBlockSpec } from '../../routines/createCustomBlockSpec.js';
import { getMediaUrl } from '../../routines/getMediaUrl.js';
import { openFilePicker } from '../../routines/openFilePicker.js';
import { ResizeHandlesWrapper } from '@blocknote/react';
import { LottieIcon } from '@contra/icons/icons';
import { lazy, Suspense, useCallback, useState } from 'react';
const LottiePlayer = lazy(async () => {
    return {
        default: (await import('@lottiefiles/react-lottie-player')).Player,
    };
});
const blockConfig = {
    content: 'none',
    fileBlockAccept: ['.json'],
    isFileBlock: true,
    propSchema: {
        caption: {
            default: '',
        },
        name: {
            default: '',
        },
        originalFormat: {
            default: '',
        },
        placeholderId: {
            default: '',
        },
        previewWidth: {
            default: 512,
        },
        sizeBytes: {
            default: 0,
        },
        uid: {
            default: '',
        },
    },
    type: 'lottie',
};
const LottieFileElement = ({ src, width }) => {
    if (typeof window === 'undefined')
        return null;
    return (_jsx(LottiePlayer, { autoplay: true, loop: true, src: src, style: { maxWidth: '100%', width } }));
};
const EditableLottieFileElement = ({ block, editor, }) => {
    const [width, setWidth] = useState(Math.min(block.props.previewWidth ?? 0, editor.domElement.firstElementChild?.clientWidth ?? 0));
    const handleAddClick = useCallback(() => {
        openFilePicker({
            block,
            editor,
        });
    }, [block, editor]);
    return block.props.uid ? (_jsx("div", { className: "bn-file-block-content-wrapper", children: _jsxs("div", { className: "contra-bn-image-and-caption-wrapper", children: [_jsx(ResizeHandlesWrapper, { block: block, 
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    editor: editor, setWidth: setWidth, width: width, children: _jsx(LottieFileElement, { src: getMediaUrl({
                            assetType: 'raw',
                            format: 'json',
                            uid: block.props.uid,
                        }), width: width }) }), _jsx(Caption, { block: block, editor: editor, onChange: (value) => {
                        editor.updateBlock(block.id, { props: { caption: value } });
                    } })] }) })) : (_jsxs("button", { className: "contra-bn-image-placeholder", onClick: handleAddClick, type: "button", children: [_jsx(LottieIcon, { color: "#677084", size: 24 }), "Add file"] }));
};
export const LottieFile = createCustomBlockSpec(blockConfig, {
    render: (props) => {
        if (props.readOnly) {
            return (_jsx(Suspense, { children: _jsx(LottieFileElement, { src: getMediaUrl({
                        assetType: 'raw',
                        format: 'json',
                        uid: props.block.props.uid,
                    }), width: props.block.props.previewWidth }) }));
        }
        return (_jsx(Suspense, { children: _jsx(EditableLottieFileElement, { block: props.block, editor: props.editor }) }));
    },
    toExternalHTML: ({ block }) => {
        const url = getMediaUrl({
            assetType: 'raw',
            format: 'json',
            uid: block.props.uid,
        });
        return _jsx("a", { href: url, children: url });
    },
});
//# sourceMappingURL=LottieFile.js.map